import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Theme } from 'ui_system/theme';

export { Theme };

export const Wrapper = styled('div')`
  width: 100%;
  margin: 0 auto;
  border-top: none;
  margin-top: 50px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    margin-bottom: 10px;
  }
`;

export const LabelBox = styled('div')`
  margin-bottom: 30px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    margin-bottom: 10px;
  }
`;

export const Label = styled('div')`
  font-size: 18px;
  font-weight: 600;
`;

export const SubLabel = styled(Label)`
  margin-bottom: 0px;
  font-size: 16px;
  color: ${Theme.colors.lightText};
  font-weight: normal;
`;

export const buttonStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 25px;
  padding-left: 25px;
  font-weight: 400;
  border-radius: 4px;
  font-size: 16px;

  :hover {
    filter: brightness(1.1);
    -webkit-filter: brightness(1.1);
  }

  i {
    font-size: 16px;
    line-height: 16px;
    margin-right: 10px;
    font-weight: 600;
  }

  border: none;
`;

export const Button = styled('button')`
  ${buttonStyle};
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : Theme.colors.green};
  color: white;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.disabled ? '0.3' : '1')};
  min-width: 100px;
`;

export const ButtonLink = styled('a')`
  ${buttonStyle};
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : Theme.colors.green};
  color: white;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.disabled ? '0.3' : '1')};

  :hover {
    color: white;
    text-decoration: none;
  }
`;

export const Section = styled('div')`
  padding: 0px 50px 50px 50px;
  max-width: 768px;
  margin: 0 auto;

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding-left: 20px;
    padding-right: 20px;
    padding: 0px 30px 30px 30px;
  }
`;
